import clsx from "clsx";
import React, { Component } from "react";

export default class SematicInput extends Component {
  render() {
    return <input className={clsx(this.props.className, 'text-2xl p-2 rounded-md border border-gray-300')} {...this.props} />;
  }
}
